module.exports = __webpack_public_path__ + "static/media/kinan-abou-afach.b5b18508.md";